module.exports = __webpack_public_path__ + "media/images/core_values/good_sense_of_humor-5c2cfd384aa08471f5bcab6591e6e672.png";